import NavigationPrimary from './NavigationPrimary'

export default NavigationPrimary
// eslint-disable-next-line import/export
export * from './NavigationPrimary'
